"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _dealerDetailsContact = _interopRequireDefault(require("../../styles/dealer-details-contact.css"));
var _dealerDetailsSecondaryHeading = _interopRequireDefault(require("./dealer-details-secondary-heading"));
var _dealerEmail = _interopRequireDefault(require("./dealer-email"));
var _dealerPhone = _interopRequireDefault(require("./dealer-phone"));
var _dealerWebsite = _interopRequireDefault(require("./dealer-website"));
var _types = _interopRequireDefault(require("../types"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  renderEmptyString = dataUtils.renderEmptyString;
var shouldRenderSecondaryHeading = function shouldRenderSecondaryHeading(secondaryHeading, theme) {
  if (secondaryHeading) {
    return /*#__PURE__*/_react["default"].createElement(_dealerDetailsSecondaryHeading["default"], {
      theme: theme,
      headingText: secondaryHeading
    });
  }
  return null;
};
var checkAndRenderPhone = function checkAndRenderPhone(countryCode, areaCode, phoneNumber, phoneClickHandler) {
  return renderEmptyString(countryCode) !== ' ' && renderEmptyString(areaCode) !== ' ' && renderEmptyString(phoneNumber) !== ' ' ? /*#__PURE__*/_react["default"].createElement(_dealerPhone["default"], {
    phoneNumber: countryCode + " " + areaCode + " " + phoneNumber,
    clickHandler: phoneClickHandler
  }) : renderEmptyString(phoneNumber) !== ' ' && /*#__PURE__*/_react["default"].createElement(_dealerPhone["default"], {
    phoneNumber: "" + phoneNumber,
    clickHandler: phoneClickHandler
  });
};
var renderProperLabel = function renderProperLabel(salesLabel, servicesLabel, usedCarsSalesLabel, bodyAndPaintLabel, code) {
  return code === 'sales' ? salesLabel : code === 'usedcarssales' ? usedCarsSalesLabel : code === 'services' ? servicesLabel : code === 'bodyandpaint' ? bodyAndPaintLabel : '';
};
var renderPhoneNumbers = function renderPhoneNumbers(_dealer, _departments, _theme, salesLabel, servicesLabel, usedCarsSalesLabel, bodyAndPaintLabel, phoneClickHandler) {
  var phoneNumbersArray = [];
  if (_dealer) {
    phoneNumbersArray.push({
      value: _dealer.phone
    });
  }
  if (_departments) {
    _departments.map(function (department) {
      return phoneNumbersArray.push({
        value: department.phone,
        code: department.code
      });
    });
  }
  var filteredNumbers = phoneNumbersArray.filter(function (elem, index, self) {
    return self.findIndex(function (item) {
      return item.value.phoneNumber === elem.value.phoneNumber && item.value.areaCode === elem.value.areaCode;
    }) === index;
  });
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: _dealerDetailsContact["default"].detailsList
  }, filteredNumbers.map(function (number, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: "phone-" + i
    }, checkAndRenderPhone(number.value.countryCode, number.value.areaCode, number.value.phoneNumber, phoneClickHandler), number.code && renderEmptyString(number.value.phoneNumber) !== ' ' && /*#__PURE__*/_react["default"].createElement("span", {
      className: _dealerDetailsContact["default"].contactLabel
    }, " (" + renderProperLabel(salesLabel, servicesLabel, usedCarsSalesLabel, bodyAndPaintLabel, number.code) + ")"));
  }));
};
var renderEmails = function renderEmails(dealer, departments, theme, salesLabel, servicesLabel, usedCarsSalesLabel, bodyAndPaintLabel, emailClickHandler) {
  var emailArray = [];
  if (dealer) {
    emailArray.push({
      email: dealer.email
    });
  }
  if (departments) {
    departments.map(function (department) {
      return emailArray.push({
        email: department.email,
        code: department.code
      });
    });
  }
  var filteredEmails = emailArray.filter(function (elem, index, self) {
    return self.findIndex(function (item) {
      return item.email === elem.email;
    }) === index;
  });
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: _dealerDetailsContact["default"].detailsList
  }, renderEmptyString(dealer.url) !== ' ' && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_dealerWebsite["default"], {
    theme: theme,
    website: dealer.url
  })), filteredEmails.map(function (item, i) {
    return item.email && item.email !== '' && /*#__PURE__*/_react["default"].createElement("li", {
      key: "email-" + i
    }, /*#__PURE__*/_react["default"].createElement(_dealerEmail["default"], {
      theme: theme,
      email: item.email,
      clickHandler: emailClickHandler
    }), item.code && /*#__PURE__*/_react["default"].createElement("span", {
      className: _dealerDetailsContact["default"].contactLabel
    }, " (" + renderProperLabel(salesLabel, servicesLabel, usedCarsSalesLabel, bodyAndPaintLabel, item.code) + ")"));
  }));
};
var DealerDetailsContact = function DealerDetailsContact(_ref) {
  var dealer = _ref.dealer,
    contactLabel = _ref.contactLabel,
    theme = _ref.theme,
    departments = _ref.departments,
    salesLabel = _ref.salesLabel,
    servicesLabel = _ref.servicesLabel,
    usedCarsSalesLabel = _ref.usedCarsSalesLabel,
    bodyAndPaintLabel = _ref.bodyAndPaintLabel,
    emailClickHandler = _ref.emailClickHandler,
    phoneClickHandler = _ref.phoneClickHandler,
    socialLabel = _ref.socialLabel,
    socialMediaLinks = _ref.socialMediaLinks;
  if (dealer && contactLabel || departments && contactLabel) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerDetailsContact["default"].contactContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _dealerDetailsContact["default"].contactCol
    }, contactLabel && shouldRenderSecondaryHeading(contactLabel, theme), /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerDetailsContact["default"].contactDetails
    }, renderEmails(dealer, departments, theme, salesLabel, servicesLabel, usedCarsSalesLabel, bodyAndPaintLabel, emailClickHandler), renderPhoneNumbers(dealer, departments, theme, salesLabel, servicesLabel, usedCarsSalesLabel, bodyAndPaintLabel, phoneClickHandler))), socialMediaLinks && socialMediaLinks.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _dealerDetailsContact["default"].contactCol
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      className: _dealerDetailsContact["default"].secondaryHeadingText + " " + theme.marginTop30 + " " + theme.marginBottom10 + " " + (theme ? theme.headingSix : '')
    }, socialLabel), /*#__PURE__*/_react["default"].createElement("ul", {
      className: _dealerDetailsContact["default"].detailsList
    }, socialMediaLinks.map(function (socialMedia, i) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: "social-media-" + i
      }, /*#__PURE__*/_react["default"].createElement("a", {
        target: "_blank",
        className: _dealerDetailsContact["default"].dealerDetailLink + " " + (theme ? theme.textLinkPrimary : '') + " " + (theme ? theme.smallType : ''),
        href: socialMedia == null ? void 0 : socialMedia.socialMediaUrl
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _dealerDetailsContact["default"].socialMediaIcon + " " + _dealerDetailsContact["default"][socialMedia.socialMediaType]
      }), socialMedia == null ? void 0 : socialMedia.socialMediaLabel));
    }))));
  }
  return null;
};
var _default = DealerDetailsContact;
exports["default"] = _default;